<template functional>
  <Route class="MainLogo" :exact="true" :title="$options.appName" to="Index">
    <Pic
      :alt="$options.appName"
      :src="$options.source(props)" />
  </Route>
</template>

<script>
import { appName } from '../../../config'

export default {
  appName,
  props: {
    size: String,
    type: { type: String, default: '' },
    format: { type: String, default: 'svg' },
  },
  source(props) {
    return [
      '/assets/logo',
      props.type,
      props.size,
    ].filter(Boolean).join('-') + '.' + props.format
  },
}
</script>

<style lang="scss">
.MainLogo {
  border: 0;
  display: inline-block;
  height: 2.5rem;

  img {
    height: 100%;
  }

  &.router-link-exact-active {
    cursor: default;
  }
}
</style>

<i18n>
{
  "en": {
    "homepage": "Homepage"
  }
}
</i18n>
